import { postApi } from '../api/digitalVault';
import { parseContents } from '../utils/parseContents';
export default async (contentChallenges, logger) => {
    const body = {
        contentChallengeResponses: {
            '@xmlns': {
                dvi: 'http://internal.dv.newbay.com/ns/1.0',
                $: 'http://dv.newbay.com/ns/1.0',
                a: 'http://alternate.newbay.com/ns/1.0',
            },
            contentChallengeResponse: contentChallenges,
        },
    };
    const contentChallengeResponse = await postApi(body, `content/query/response`, {}, logger);
    return parseContents(contentChallengeResponse);
};
